import moment from 'moment';
import "moment/min/locales";
moment.locale('tr');

export default moment;